var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modalSiNo",attrs:{"titulo":_vm.titulo,"no-guardar":"","no-cancelar":"","no-aceptar":"","btns":_vm.btns,"icon":_vm.icon},on:{"accion":_vm.accion}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row my-3 text-muted f-14 justify-center text-center px-3"},[_vm._v(" "+_vm._s(_vm.mensaje)+" ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }